import { Box } from 'src/design/atoms/Box';
import { Grid } from 'src/design/atoms/Grid';
import React from 'react';
import { Rate } from 'src/api/FiretrolApiClient';
import { DeleteButton } from 'src/design/atoms/DeleteButton';

export interface IStaticItemProps {
  rate: Rate;
  onRemove: () => void;
}

export const StaticItem: React.FC<IStaticItemProps> = ({ rate, onRemove }) => {
  return (
    <Grid>
      <Grid.Col span={6}>
        <Box py="xs">{rate.label}</Box>
      </Grid.Col>
      <Grid.Col span={4}>
        <Box py="xs">
          ${rate.rate1} /{rate.rateMeasurement}
        </Box>
      </Grid.Col>
      <Grid.Col span="auto" ta="right">
        <DeleteButton size="compact-sm" onClick={onRemove} />
      </Grid.Col>
    </Grid>
  );
};
